import styled, { css } from "styled-components";
import { getBackgroundColor } from "../../../../../ui/_themes/helpers";
import { iPadPortraitOnly } from "../../../../../ui/_utils/styleUtils";

export const KeypadWrapper = styled.div`
  display: ${props => (props.hidden ? "none" : "flex")};
  flex-direction: column;
  flex: 0 0 auto;
  width: 100%;
  justify-content: flex-end;

  @media (orientation: landscape) {
    flex: 1 0 auto;
  }
`;

export const GameArea = styled.div`
  display: flex;
  flex: 1 1 auto;

  @media (orientation: landscape) {
    display: none;
  }
`;

export const DisplaysWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0.2em 0.8em;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  @media (orientation: landscape) {
    padding: 0 2.4em;
  }
`;

export const SpinButtonWrapper = styled.div`
  position: relative;
  display: inherit;
  align-items: center;
  justify-content: center;

  @media (orientation: landscape) {
    padding: 2em 0;
  }

  ${iPadPortraitOnly(css`
    padding: 0 2em;
  `)}
`;

export const BottomPanel = styled.div`
  pointer-events: all;
  width: 100%;
  background: ${getBackgroundColor("displays")};
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: flex-end;

  @media (orientation: landscape) {
    padding: 0.3em 0 0;
  }
`;
